import React from 'react';
import { DEFAULT_TEXTAREA_PLACEHOLDER } from '../../../config/surveys/defaults';

interface TextareaQuestionProps {
  questionId: string;
  value: string | undefined;
  onChange: (value: string) => void;
  placeholder?: string;
  rows?: number;
}

const TextareaQuestion: React.FC<TextareaQuestionProps> = ({
  questionId,
  value,
  onChange,
  placeholder = DEFAULT_TEXTAREA_PLACEHOLDER,
  rows = 6,
}) => {
  return (
    <textarea
      id={questionId}
      value={value || ''}
      onChange={(e) => onChange(e.target.value)}
      placeholder={placeholder}
      rows={rows}
      className="textarea-input"
    />
  );
};

export default TextareaQuestion;
